import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Users, Star } from 'lucide-react';
import { PriceCta } from './ui/PriceCta';
export function FinalCta() {
  return <section className="py-32 px-6 bg-ink text-bone text-center" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-57">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-12 leading-tight" data-id="element-58">
            Es momento de apagar el piloto automático.
          </h2>

          <div className="max-w-md mx-auto mb-10" data-id="element-59">
            <PriceCta variant="dark" data-id="element-60" />
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-sm text-bone/70" data-id="element-61">
            <div className="flex items-center gap-2" data-id="element-62">
              <ShieldCheck size={18} className="text-sage" data-id="element-63" />
              <span data-id="element-64">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-65">
              <CreditCard size={18} className="text-sage" data-id="element-66" />
              <span data-id="element-67">Mercado Pago disponible</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-68">
              <Users size={18} className="text-sage" data-id="element-69" />
              <span data-id="element-70">Más de 500 personas ya recuperaron el control</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-71">
              <Star size={18} className="text-oxblood fill-oxblood" data-id="element-72" />
              <span data-id="element-73">4.9/5 de Calificación</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}